import { CodeItem } from 'app/area/indicator-factors/item/types-store';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { ValidationProps, ValidationLevel } from 'ui/common/validation/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodetableTranslation } from 'app/area/indicator-factors/constants';

export interface ValidationData {
  codeItem: CodeItem;
  translation: CodetableTranslation;
}

export const validate = (validationData: ValidationData): { [key: string]: ValidationProps } => {
  const { codeItem, translation } = validationData;

  const substanceValidation = validatePicker(CodeFieldWireKey.substance, codeItem, translation);
  const substanceUomValidation = validatePicker(CodeFieldWireKey.substanceUom, codeItem, translation);
  const indicatorSubstanceValidation = validatePicker(CodeFieldWireKey.indicatorSubstance, codeItem, translation);
  const indicatorSubstanceUomValidation = validatePicker(CodeFieldWireKey.indicatorSubstanceUom, codeItem, translation);
  const indicatorTypeValidation = validatePicker(CodeFieldWireKey.indicatorType, codeItem, translation);
  const factorValidation = validateTextarea(CodeFieldWireKey.factor, codeItem, translation);
  const validFromValidation = validateTextarea(CodeFieldWireKey.validFrom, codeItem, translation);

  return {
    ...substanceValidation,
    ...substanceUomValidation,
    ...indicatorSubstanceValidation,
    ...indicatorSubstanceUomValidation,
    ...indicatorTypeValidation,
    ...factorValidation,
    ...validFromValidation
  };
};

const validatePicker = (
  id: string,
  codeItem: CodeItem,
  translation: CodetableTranslation
): { [key: string]: ValidationProps } => {
  return {
    [id]: isDefinedIncludingZero(codeItem[id]?.value) ? undefined : {
      level: ValidationLevel.error,
      messages: [{
        level: ValidationLevel.error,
        message: translation.must_be_filled_out
      }]
    }
  };
};

const validateTextarea = (
  id: CodeFieldWireKey,
  codeItem: CodeItem,
  translation: CodetableTranslation
): { [key: string]: ValidationProps } => {
  return {
    [id]: isDefinedIncludingZero(codeItem[id]) ? undefined : {
      level: ValidationLevel.error,
      messages: [{
        level: ValidationLevel.error,
        message: translation.must_be_filled_out
      }]
    }
  };
};
